// TODO アスファルト・コンクリ対応 STEP2に含めない場合ファイルごと削除
import React from "react";
import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { FilterSurface } from "../../../services/actions/SurfaceAction";

import { Box, Button, Tooltip } from "@material-ui/core";
import { Clear as ClearIcon } from "@material-ui/icons";
import { compareArray } from "../../../shared/utils/objectExtensions";
import { withTranslation, Trans } from "react-i18next";
import { SURFACE_TYPES } from "../../../shared/utils/constant";

const FilterRoadSurface = ({
  surveyedMapType,
  surfaceFilters,
  vectorTiles,
  FilterSurface,
}) => {
  return surveyedMapType === 'point' && vectorTiles?.point?.isSurface === true && (
    <div className="filter-road-surfce-card">
      <p>
        <Trans>road_surface_type</Trans>
      </p>
      {/* Surface Type項目選択部 */}
      {SURFACE_TYPES.map((x, idx) => (
        <div
          key={idx}
          className={`surface-label hover ${
            surfaceFilters &&
            surfaceFilters.length > 0 &&
            surfaceFilters.find(
              (s) => x.title == s.title
            ) &&
            "selected"
          }`}
          onClick={() => {
            // closeSurveyedDetail();
            FilterSurface(x);
          }}
        >
          <Box
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {/* <Box width={18}>
              <div
                style={{ backgroundColor: x.color }}
                className="surface-dot"
              />
            </Box> */}
            <Tooltip title={x.title} placement="top">
              <span
                dangerouslySetInnerHTML={{
                  __html: `${x.title}`,
                }}
              />
            </Tooltip>
          </Box>
        </div>
      ))}
      {/* Clear Filter部 */}
      {surfaceFilters && surfaceFilters.length > 0 && (
        <div
          className="surface-label"
          onClick={() => {
            // closeSurveyedDetail();
            FilterSurface(null);
          }}
        >
          <Button size="small" startIcon={<ClearIcon />}>
            <Trans>clear_filter</Trans>
          </Button>
        </div>
      )}
    </div>
  );
};
export default compose(
  withTranslation("translations"),
  connect(
    (state) => ({
      surveyedMapType: state.gis.surveyedMapType,
      surfaceFilters: state.surface.surfaceFilters,
      vectorTiles: state.road.vectorTiles
    }),
    (dispatch) => ({
      FilterSurface: (surface) => dispatch(FilterSurface(surface)),
    })
  ),
  lifecycle({})
)(FilterRoadSurface);
